/* 悬浮沟通窗「弹出独立窗口」：主页面 ↔ 独立聊天窗口 之间用 BroadcastChannel（同源所有标签页）+ opener.postMessage（精确回到打开它的那个主页面）通信；
   独立窗口位置 / 大小记在 localStorage，再次弹出回到同一块屏幕 */
const BUS = "ali_comm_popout";
export const POP_NAME = "ali_chat_popout";
const RECT_KEY = "comm_popout_rect";
export const isPopoutWindow = () => typeof window !== "undefined" && window.name === POP_NAME;

export const popoutBus = () => (typeof BroadcastChannel !== "undefined" ? new BroadcastChannel(BUS) : null);
export const loadPopRect = () => { try { return JSON.parse(localStorage.getItem(RECT_KEY) || "null"); } catch { return null; } };
export const savePopRect = (r) => { try { localStorage.setItem(RECT_KEY, JSON.stringify(r)); } catch { /* ignore */ } };
export const clearPopRect = () => { try { localStorage.removeItem(RECT_KEY); } catch { /* ignore */ } };

export const popoutPath = (t) => (t?.messageId ? `/chat-popout/m/${t.messageId}` : t?.channelId ? `/chat-popout/c/${t.channelId}` : "/chat-popout");

/* 主页面：打开（或聚焦已存在的）独立聊天窗口；必须由用户点击直接触发，否则会被浏览器拦截 */
export function openChatPopout(target) {
  const s = window.screen || {};
  const aw = s.availWidth || window.innerWidth, ah = s.availHeight || window.innerHeight;
  const r = loadPopRect() || { w: Math.min(1280, aw - 80), h: Math.min(820, ah - 80), x: (window.screenX || 0) + 60, y: (window.screenY || 0) + 60 };
  const feats = `popup=yes,width=${Math.max(720, r.w)},height=${Math.max(520, r.h)},left=${r.x},top=${r.y},resizable=yes,scrollbars=yes`;
  const w = window.open(popoutPath(target), POP_NAME, feats);
  try { w?.focus(); } catch { /* ignore */ }
  return w;
}

/* 独立窗口 → 主页面：优先发给 opener（打开它的那个页面）并聚焦；否则广播给所有主页面 */
export function sendToMain(msg) {
  try {
    if (window.opener && !window.opener.closed) {
      window.opener.postMessage({ type: "ali_comm", msg }, window.location.origin);
      try { window.opener.focus(); } catch { /* ignore */ }
      return;
    }
  } catch { /* cross-origin opener → fall through */ }
  const b = popoutBus();
  b?.postMessage(msg);
  setTimeout(() => b?.close(), 200);
}
